import styled from "styled-components"

export const Input = styled.input`
  padding: 12px 10px;
  font-size: 0.85rem;
  background-color: white;
  border: 1px solid #d2d2d2;
  border-radius: 2px;
`
